import React from 'react';
import { Typography } from '@material-ui/core';
import { FuseAnimate } from '@fuse';
import pJSON from '../../../../package.json';

const BrandingPanel = () => {
	return (
		<div className="flex flex-col flex-1 items-center justify-center text-white p-16 text-center md:p-64 md:items-start md:flex-shrink-0 md:text-left">
			<FuseAnimate delay={400}>
				<div className="max-w-640">
					<div className="flex flex-col items-center justify-center my-40">
						<img style={{ width: '440px', marginBottom: '16px' }} src="assets/images/logos/heidi.svg" alt="Heidi AI logo" />
					</div>
					<Typography variant="subtitle1" color="inherit">
						Heidi AI is your gateway to the world of advanced computing! Designed for educational institutions, research labs, and organizations of all sizes, Heidi AI provides a powerful platform to explore and harness the capabilities of high-performance computing and supercomputing.
					</Typography>
					<Typography variant="subtitle1" color="inherit" className="mt-16">
						Learn. Create. Innovate.
						{' '}Whether you're conducting groundbreaking research, solving complex computational problems, running large-scale simulations, training AI models, or exploring data science, Heidi AI empowers you to turn your ideas into reality.
					</Typography>
					<Typography variant="body2" color="inherit" className="mt-16" style={{ fontWeight: 300, fontStyle: 'italic' }}>
						Powered by Adaptive Computing Enterprises, Inc.
					</Typography>
					<Typography variant="subtitle1" color="inherit" className="mt-16">
						Version {pJSON.version}
					</Typography>
				</div>
			</FuseAnimate>
		</div>
	);
};

export default BrandingPanel;
